import React, { useEffect, useState } from "react";
import { motion, useScroll } from "framer-motion";

const ScrollIndicator = () => {
  const { scrollYProgress } = useScroll();
  const [shouldShow, setShouldShow] = useState(true);

  useEffect(() => {
    const checkVisibility = () => {
      const bodyOverflow = getComputedStyle(document.body).overflow;
      const bodyHeight = document.body.scrollHeight;
      const windowHeight = window.innerHeight;

      const noOverflow = bodyOverflow === "hidden";
      const noScroll = bodyHeight <= windowHeight;

      setShouldShow(!noOverflow && !noScroll);
    };

    checkVisibility();

    // Listen to resize and mutation changes
    const handleResize = () => checkVisibility();
    window.addEventListener("resize", handleResize);

    const observer = new MutationObserver(checkVisibility);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style", "class"],
      childList: true,
      subtree: true,
    });

    return () => {
      window.removeEventListener("resize", handleResize);
      observer.disconnect();
    };
  }, []);

  if (!shouldShow) return null;

  return (
    <motion.div
      id="scroll-indicator"
      style={{
        scaleX: scrollYProgress,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 4,
        originX: 0,
        boxShadow: "0 0px 5px rgba(0, 0, 0, 0.5)",
        zIndex: 100000000,
        background:
          "linear-gradient(90deg,rgba(240, 95, 88, 1) 0%, rgba(255, 214, 0, 1) 25%, rgba(145, 196, 81, 1) 50%, rgba(64, 168, 196, 1) 100%)",
      }}
    />
  );
};

export default ScrollIndicator;
